module.exports = __webpack_public_path__ + "static/media/Siddhi Shinde.d70eda83.jpg";